import { EditableSectionContainer, EditableSectionRow } from '@uplift/ui-v2';
import { MatchingProfileRow } from '@uplift/types';
import { useProfileContext } from '../profile.context';
import { IconWithContent } from '../components/IconWithContent.component';
import { Box, Typography } from '@mui/material';
import { CalendarDateService } from '@uplift/services';
import { useProfileStyles } from '../styles';
import { profileRowKeyToLabel } from '../profile.utils';
import { useStates } from '@uplift/queries';
import { LicenseIcon } from '@uplift/icons';
import { useMemo } from 'react';
import { PendingTypography } from '../components/PendingTypography.component';

export const CredentialingSection: React.FC = () => {
  const { classes } = useProfileStyles();
  const { profile } = useProfileContext();
  const { states } = useStates();

  const liceses = useMemo(() => {
    if (profile.licenses.length) {
      return (
        <Box display="flex" flexDirection="column" gap="1.5rem">
          {profile.licenses.map((license) => {
            const stateShortName = states.find(x => x.id === license.stateId)?.shortName;

            return (
              <IconWithContent
                key={license.id}
                icon={<LicenseIcon />}
                primary={`${license.role.name}, ${stateShortName}, ${license.number}`}
                secondary={<Typography color="textSecondary">Expires <Typography component="span" color="textPrimary" className={classes.fontWeight500}>{CalendarDateService.date(license.expiration).format('MM/YY')}</Typography></Typography>}
                disableSecondaryTypography
              />
            );
          })}
        </Box>
      );
    }

    return <PendingTypography />;
  }, [ classes.fontWeight500, profile.licenses, states ]);

  const insuranceCompanyNames = profile.supportedInsuranceCompanies.map(insurance => insurance.shortName);

  const insuranceCompanies = useMemo(() => {
    if (profile.supportedInsuranceCompanies.length) {
      return (
        <Typography className={classes.fontWeight500}>
          {insuranceCompanyNames.join(', ')}
        </Typography>
      );
    }

    return <PendingTypography />;
  }, [ classes.fontWeight500, insuranceCompanyNames ]);

  const npi = useMemo(() => {
    if (profile.npi) {
      return (
        <Typography className={classes.fontWeight500}>
          {profile.npi}
        </Typography>
      );
    }

    return <PendingTypography />;
  }, [ classes.fontWeight500, profile.npi ]);

  return (
    <EditableSectionContainer
      title="Credentialing"
      rowDividers
      formikConfigs={{}}
    >
      <EditableSectionRow
        label={profileRowKeyToLabel.acceptedInsurance}
        rowKey={MatchingProfileRow.acceptedInsurance}
        kind="custom"
      >
        {insuranceCompanies}
      </EditableSectionRow>
      <EditableSectionRow
        label={profileRowKeyToLabel.licenses}
        rowKey={MatchingProfileRow.licenses}
        kind="custom"
      >
        {liceses}
      </EditableSectionRow>
      <EditableSectionRow
        label={profileRowKeyToLabel.npi}
        rowKey={MatchingProfileRow.npi}
        kind="custom"
      >
        {npi}
      </EditableSectionRow>
    </EditableSectionContainer>
  );
};
